import { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import BreadCrumb from '../../../../component/BreadCrumb';
import InputBox from '../../../../component/InputBox';
import AuthenticationUtil from '../../../../util/AuthenticationUtil';
import { usePrompt } from '../../../../util/PromptUtil';
import CommunityPostEditorInfoBox from '../../../../component/CommunityPostEditorInfoBox';
import TextEditor from '../../../../component/editor/TextEditor';
import { COMMUNITY_FAQ_DETAIL_PATH, COMMUNITY_FAQ_PATH, PATH_DELIMITER, ROLE } from '../../../../constant/Constant';
import { actionEdit, actionDetail } from '../../../../module/body/community/faq/CommunityFaqModule';
import { VIEW_COMMUNITY_FAQ_EDIT } from '../../../../constant/ViewConstant';
import CancelButtonBox from '../../../../component/buttons/CancelButtonBox';
import ConfirmButtonBox from '../../../../component/buttons/ConfirmButtonBox';
import NullCheckUtil from '../../../../util/NullCheckUtil';
import CodeUtil from '../../../../util/CodeUtil';
import PopupRef from '../../../../component/PopupRef';
import { CODE_GROUP_ID } from '../../../../constant/Constant';

const CommunityFaqEditView = () => {
    let params = useParams();
    // const auth = AuthenticationUtil.get();
    // usePrompt('현재 페이지를 벗어나시겠습니까?', true);

    const [postingNo, setPostingNo] = useState(params && params.postingNo);
    const [postingTitleNm, setPostingTitleNm] = useState('');
    const [postingCtnt, setPostingCtnt] = useState('');
    const [universityNm, setUniversityNm] = useState('');
    const [userNm, setUserNm] = useState('');
    const [regDttm, setRegDttm] = useState('');
    const [hasAuth, setHasAuth] = useState(false);
    const [editPermission, setEditPermission] = useState(false);

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const popupRef = useRef(null);

    useEffect(() => {
        window.scrollTo(0, 0);
        initSearch(params.postingNo);
    }, []);

    const initSearch = (postingNo) => {
        dispatch(
            actionDetail({
                params: { postingNo },
                callback: (result) => {
                    setDetail(result);
                },
            }),
        );
    };

    const setDetail = (result) => {
        setPostingTitleNm(result.postingTitleNm);
        setPostingCtnt(result.postingCtnt);
        if (NullCheckUtil.isNotEmpty(result.userUniversityCd)) {
            setUniversityNm(
                CodeUtil.getCodes(CODE_GROUP_ID.USER_UNIVERSITY).find((el) => el.cd == result.userUniversityCd).cdNm,
            );
        }
        setUserNm(result.userNm);
        setRegDttm(result.regDttm);

        if (
            AuthenticationUtil.getUserRoleCd() == ROLE.ADMIN ||
            (AuthenticationUtil.getUserRoleCd() == ROLE.STAFF && AuthenticationUtil.getUserId() == result.regUserId)
        ) {
            setEditPermission(true);
        } else {
            popupRef.current.openAlert('FAQ 수정 권한이 부족합니다. FAQ 목록 조회 화면으로 이동합니다.', () => {
                return function () {
                    navigate(COMMUNITY_FAQ_PATH);
                };
            });
        }
    };

    const handleCancel = () => {
        var path = COMMUNITY_FAQ_DETAIL_PATH + PATH_DELIMITER + postingNo;
        navigate(path);
    };

    const handleConfirm = () => {
        if (validateFaq()) {
            dispatch(
                actionEdit({
                    params: {
                        postingNo,
                        postingTitleNm,
                        postingCtnt,
                    },
                    callback: (pno) => {
                        popupRef.current.openAlert('게시물 번호 ' + pno + '이 수정되었습니다.', () => {
                            return function () {
                                var path = COMMUNITY_FAQ_DETAIL_PATH + PATH_DELIMITER + postingNo;
                                navigate(path);
                            };
                        });
                    },
                }),
            );
        }
    };

    const validateFaq = () => {
        if (!editPermission) {
            popupRef.current.openAlert('로그인하신 사용자의 권한이 부족합니다.');
            return false;
        }
        if (NullCheckUtil.isEmpty(postingTitleNm)) {
            popupRef.current.openAlert('제목을 입력해주세요.');
            return false;
        }
        if (NullCheckUtil.isEmpty(postingCtnt)) {
            popupRef.current.openAlert('내용을 입력해주세요.');
            return false;
        }
        return true;
    };

    return (
        <section className='container'>
            <div className='container-inner'>
                <div className='con-title-wrap conbg04'>
                    {/* <h2 className='con-title'>FAQ</h2> */}
                    <h2 className='con-title'>{VIEW_COMMUNITY_FAQ_EDIT.title}</h2>
                    <p className='con-title-p'>{VIEW_COMMUNITY_FAQ_EDIT.subTitle}</p>
                </div>
                <div className='sub-nav-wrap'>
                    <BreadCrumb />
                </div>
                <div className='community-wrap'>
                    <div className='cmnty-top-box'>
                        <div className='top-box-row full'>
                            <InputBox
                                title='제목'
                                value={postingTitleNm}
                                onChange={(e) => setPostingTitleNm(e.target.value)}
                            />
                        </div>
                    </div>
                    <TextEditor className='cmnty-wrt-box' value={postingCtnt} onChange={setPostingCtnt} />
                    <CommunityPostEditorInfoBox userNm={userNm} universityNm={universityNm} regDttm={regDttm} />
                    <div className='cmnty-btn-box btn-wrap'>
                        <CancelButtonBox title='취소' onClick={(e) => handleCancel()} />
                        <ConfirmButtonBox title='확인' onClick={(e) => handleConfirm()} />
                    </div>
                </div>
            </div>
            <PopupRef ref={popupRef} />
        </section>
    );
};

export default CommunityFaqEditView;
